export default "/_next/static/images/MembershipBGMobile-3338291d6b939e5469028d8cb27fe246.png";